module.exports = __webpack_public_path__ + "img/ИФ-1(А)-032.ee1ba36b.png";